var exports = {
  "k": "xa15a2ab7--3a4e3b--container",
  "D": "xa15a2ab7--3a4e3b--title",
};

module.exports = exports;
